import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {Frequency} from '../models/frequency';

@Injectable({
  providedIn: 'root'
})
export class TotenService {

  public spinner: boolean = false;
  public msgError: any = ""

  constructor (
    private _httpClient: HttpClient,
    private db: AngularFirestore,

  ) { }

  /*
  getUserSubscription50 (doc: any): Observable<any> {
    this.spinner = true
    this.msgError = ''

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscription50';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    console.log("doc: " + JSON.stringify(body))

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          this.spinner = false
          console.log("error: " + JSON.stringify(error))
          return throwError(error.status);
        })
      )
  }
  */

  getUserSubscription52 (doc: any): Observable<any> {
    this.spinner = true
    this.msgError = ''

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscription52';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    console.log("doc: " + JSON.stringify(body))

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          this.spinner = false
          console.log("error: " + JSON.stringify(error))
          return throwError(error.status);
        })
      )
  }

  getUserSubscriptionBJCVS (doc: any): Observable<any> {
    this.spinner = true
    this.msgError = ''

    let url = 'https://us-central1-sbccv-proj.cloudfunctions.net/getUserSubscriptionBJCVS';

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const body: any = {'doc': doc}
    console.log("doc: " + JSON.stringify(body))

    return this._httpClient.post<any>(url, body, httpOptions)
      .pipe(
        retry(2),
        catchError((error) => {
          this.spinner = false
          console.log("error: " + JSON.stringify(error))
          return throwError(error.status);
        })
      )
  }

  loadFrequency (event_id) {
    return this.db.collection<Frequency>('sbccv_inout', ref => ref
      .where('event_id', '==', event_id)
      .orderBy('date', 'desc')).snapshotChanges();
  }

  selectEvents () {

  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_inout').doc(entity_id).delete();
  }
}
